import React from "react";
import { Container } from "@raketa-cms/raketa-cms";
import ReCAPTCHA from "react-google-recaptcha";
import Input from "../frontend/UncontrolledInput";

const NegativeFeedbackWidget = ({ title, subtitle, formUrl, containerSettings }) => {
  const [submitting, setSubmitting] = React.useState(false);
  const [recaptcha, setRecaptcha] = React.useState("");

  return (
    <Container settings={containerSettings}>
      <div className="container">
        <div className="row">
          <div className="shift-3">
            <div className="negative-feedback-widget">
              <div className="text-center">
                <h2>{title}</h2>
                <p>{subtitle}</p>
              </div>

              <div className="form">
                <form
                  method="POST"
                  action={formUrl}
                  onSubmit={() => {
                    setSubmitting(true);
                  }}
                >
                  <div className="form-row">
                    <div className="form-item">
                      <Input
                        type="text"
                        name="data[name]"
                        id="data_name"
                        label="Name"
                        required
                        maxLength="50"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-item">
                      <Input
                        type="email"
                        name="data[email]"
                        id="data_email"
                        label="Email"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-item">
                      <Input
                        type="textarea"
                        name="data[comment]"
                        id="data_comment"
                        label="Comment"
                        required
                      />
                    </div>
                  </div>

                  <div className="captcha">
                    <ReCAPTCHA
                      sitekey="6LfOXSUcAAAAAHgluB7FB5JrlEDkeWj9O7lNHULc"
                      onChange={(value) => setRecaptcha(value)}
                    />
                  </div>

                  <Input type="hidden" name="g-recaptcha-response" value={recaptcha} />

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn-primary lg"
                      disabled={submitting || !recaptcha}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div >
    </Container >
  );
};

NegativeFeedbackWidget.title = "Negative Feedback Form";
NegativeFeedbackWidget.category = "Forms";

NegativeFeedbackWidget.defaults = {
  title: "We are sorry you didn't have a great experience.",
  subtitle: "Please tell us how we could improve.",
  formUrl: "https://forms.raketa.cloud/submit/nAx-NYYwCP",
  containerSettings: {},
};

NegativeFeedbackWidget.adminFields = {
  title: { type: "text" },
  subtitle: { type: "textarea" },
  formUrl: { type: "text" },
};

export default NegativeFeedbackWidget;
